export function toRawType(val) {
  return {}.toString.call(val).slice(8, -1)
}

export function filterData(data) {
  if (toRawType(data) !== 'Object') {
    return data
  }
  Object.keys(data).forEach((key) => {
    const val = data[key]
    if (!val && val !== 0) {
      delete data[key]
    } else if (toRawType(val) === 'Array') {
      if (!val.length) {
        delete data[key]
      }
    }
  })
  return data
}

export function download(data, fileName, mineType) {
  // 创建 blob
  let type = mineType || 'application/vnd.ms-excel;charset=utf-8'
  let blob = new Blob([data], { type: type });
  // 创建 href 超链接，点击进行下载
  window.URL = window.URL || window.webkitURL;
  let href = URL.createObjectURL(blob);
  let downA = document.createElement("a");
  downA.href = href;
  downA.download = fileName;
  downA.click();
  // 销毁超连接
  window.URL.revokeObjectURL(href);
}

// 回显数据字典
// datas：当前数据,
// value：当前值,
// code：对应编码字段,  默认为：dictValue
// label：对应文字字段, 默认为：dictLabel
// isNum：字段是否为数字
export function selectDictLabel(datas, value, isNum, code, label) {
  if (value !== 0 && !value) return ''
  if (!datas) return value
  let dictValue = code ? code : 'dictValue'
  let dictLabel = label ? label : 'dictLabel'
  const actions = []
  Object.keys(datas).some((key) => {
    if (datas[key][dictValue] === (isNum ? value : '' + value)) {
      actions.push(datas[key][dictLabel])
      return true
    }
  })
  return actions.join('')
}

export function handleTree(data, id, parentId, children) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  }

  const childrenListMap = {}
  const nodeIds = {}
  const tree = []

  for (const d of data) {
    const parentId = d[config.parentId]
    if (!childrenListMap[parentId]) {
      childrenListMap[parentId] = []
    }
    // tree-select and el-cascader
    d.value = d[config.id]
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    if (!nodeIds[parentId]) {
      tree.push(d)
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]]) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }

  return tree
}
// 去除树形结构 空的 children 
export function removeEmptyChildren(node) {
  node.forEach(item => {
    if ('children' in item && item.children.length === 0) {
      delete item.children
    } else if ('children' in item && item.children.length) {
      removeEmptyChildren(item.children)
    }
  })
  return node
}


// WEBPACK FOOTER //
// ./src/utils/index.js